import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import liffHelper from '../../utils/liffHelper';
import { Redirect } from 'react-router-dom'
import Header from './Header';

// const styles = theme => {
//   return ({
//       myTab: {
//         fontFamily: 'Courier New',
//     });
// }

const useStyles = makeStyles(theme => ({
  // return ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      width: 120,
      '&:focus': {
        width: 200,
      },
    },
  },
  bigAvatar: {
    margin: 10,
    width: 60,
    height: 60,
  },
  avatar: {
    margin: 10,
  },
}));



// export default function SearchAppBar() {
export default class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {
        pictureUrl: "https://linebotkeep-file.s3-ap-southeast-1.amazonaws.com/QR/4-512.png",
        displayName: 'Displayname',
      },
      mongo: {
        Ck_Name: 'false'
      },
      redi:{
        redirect: false,
      }
    };
  }
  async componentDidMount() {
  const  profile = await liffHelper.getProfile2()
  this.setState({ profile });
//   const  nna = await liffHelper.checkmongo(this.state.profile.userId)
//   // alert(nna)
//   if(nna != undefined){
//   this.setState({
//     mongo: {
//       ...this.state.mongo,
//       Ck_Name: nna.Ck_Name,
//     }
//   })
//   }else{
//     this.setState({
//       redi: {
//         ...this.state.redi,
//         redirect: true,
//       }
//     })
//   }
}
  renderRedirect = () => {
    if (this.state.redi.redirect != false) {
      return <Redirect to='/message' />
    }
  }

  render() {
    const classes = this.props;

    return (
      <div className={classes.root}>
        
        <AppBar position="static">
          <Toolbar>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="open drawer"
            >
              <MenuIcon />
            </IconButton>
            <Grid container justify="space-between" alignItems="center">
              {this.renderRedirect()}  
              {this.state.profile.displayName}
              <div>
                <Avatar alt="Remy Sharp" src={this.state.profile.pictureUrl} className={classes.avatar} />
              </div>
            </Grid>
          </Toolbar>
        </AppBar>
        
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/components/ProfileNoredi.js